import { createRoot } from 'react-dom/client';
import { init as initFMS } from '@/fms';
import { createCookieClient } from '@bank/stb-cookies';
import { LiveAnnouncer } from '@bank/components';
import { initMonitoring, logError } from '@/monitoring';
import { isDevEnv } from '@/utils/env';
import auth from './auth';
import './index.css';

async function bootstrap() {
  if (isDevEnv) {
    const { setupKronWebViewDevStub } =
      await import('@/app/utils/kronWebViewDevStub');
    setupKronWebViewDevStub();
  }

  await initFMS();

  await auth.init();
  initMonitoring(
    auth.authenticated
      ? { id: auth.idTokenParsed.sub, cmid: auth.idTokenParsed.cm_id }
      : {},
  );

  if (auth.authenticated) {
    void createCookieClient({
      clientId: window.env.CLIENT_ID,
      apiRoot: window.env.WEB_API_ROOT,
      cookieDomain: window.env.COOKIE_DOMAIN,
      getToken: () => auth.getToken(),
      onError: logError,
    })
      .syncAll()
      .catch(logError);
  }

  const rootNode = document.getElementById('root');

  if (!rootNode) {
    throw new Error('Cannot mount react, #root element is not available');
  }

  const { App } = await import('@/app');
  createRoot(rootNode).render(
    <>
      <LiveAnnouncer />
      <App />
    </>,
  );
}

await bootstrap();
